/**
 * 알림톡 등 네이티브 딥링크(`maketrend:///main?deeplink={action}`)가 전달하는 진입 액션.
 *
 * 네이티브 `DeepLinkRouter` 가 커스텀 스킴을 `https://{webBase}/main?deeplink={action}` 으로
 * 패스스루하면, `DeepLinkCapture` 가 이 값을 읽어 알려진 action 만 저장한다(미지값은 무시 —
 * 향후 recommend/notice 등 확장 시 store 오염 방지).
 */
export const DEEPLINK_ACTION = {
  EXAM_OPEN: "exam_open",
  /** 카카오톡 초대 공유 메시지의 "내 수수료 보러 가기" → 초대 코드(추천인) 등록 화면. */
  INVITE_CODE_REGISTER: "invite_code_register",
} as const;

/** `/main?deeplink={action}` 쿼리 파라미터 이름 — 생성부(초대 공유 링크)와 소비부(DeepLinkCapture)가 공유하는 계약. */
export const DEEPLINK_QUERY_PARAM = "deeplink";

export type DeeplinkAction = (typeof DEEPLINK_ACTION)[keyof typeof DEEPLINK_ACTION];

export const isDeeplinkAction = (v: string | null): v is DeeplinkAction =>
  v != null && Object.values(DEEPLINK_ACTION).includes(v as DeeplinkAction);

/**
 * 초대 링크의 비식별 공유 코드 파라미터 — 서버 발급 `referralShareCode` 를 싣는다.
 * 전화번호가 아니므로 개인정보 게이트 해당 없음 (서버 계약:
 * `_docs/outer/api/features/referral/share-link-api-guide.md`).
 */
export const SHARE_CODE_QUERY_PARAM = "share_code";

/**
 * 공유 코드 형식 — 서버 계약 `^[0-9A-Za-z]{12}$` (base62 12자, 백필 hex 도 부분집합).
 * 캡처(sanitize)와 API 선검증이 공유하는 단일 소스.
 */
export const SHARE_CODE_REGEX = /^[0-9A-Za-z]{12}$/;

/**
 * 링크로 들어온 공유 코드 검증 — base62 12자만 유효.
 * 손상·위조·미치환(`${SHARE_CODE}` 리터럴) 값은 null → 자동 preview 만 포기하고 수동 입력 폴백.
 */
export const sanitizeShareCode = (raw: string | null): string | null =>
  raw != null && SHARE_CODE_REGEX.test(raw) ? raw : null;
